export enum IntegrationType {
  Cases = 'CASE', // Anciennement pour les utilisateurs LIGHT
  Reminders = 'REMINDERS', // Anciennement pour les utilisateurs STANDARD
}

export const MASTER_TYPE = {
  B2B: 'B2B',
  B2C: 'B2C',
};
export const EVENT_TYPE = {
  PROMISE: 'PROMISE',
  DISPUTE: 'DISPUTE',
  DEBT_COLLECTION_DELEGATION: 'DEBT_COLLECTION_DELEGATION',
  FORMAL_NOTICE: 'FORMAL_NOTICE',
  REMINDER: 'REMINDER',
};

export const PLANNED_REMINDER = {
  MEDIA: {
    PHONE: 'PHONE',
    LETTER: 'LETTER',
    EMAIL: 'EMAIL',
  },
  STATUS: {
    CANCELED: 'CANCELLED',
    PLANNED: 'PLANNED',
  },
};

export const ORIGIN = {
  COCKPIT: 'COCKPIT',
  WEB: 'WEB',
};

export const REGEX: any = {
  DATE: {
    FR: new RegExp(
      '^([0-9]|[0-2][0-9]|(3)[0-1])(/)(([0-9]|(0)[0-9])|((1)[0-2]))(/)\\d{4}$',
    ), // => dd/MM/yyyy
    INTERNATIONAL: new RegExp(
      '^\\d{4}(-)(([0-9]|(0)[0-9])|((1)[0-2]))(-)([0-9]|[0-2][0-9]|(3)[0-1])$',
    ), // => yyyy-MM-dd
    US: new RegExp(
      '^(([0-9]|(0)[0-9])|((1)[0-2]))(-)([0-9]|[0-2][0-9]|(3)[0-1])(-)\\d{4}$',
    ), // => MM-dd-yyyy
  },
  FORMAT: {
    FR: 'dd/MM/yyyy',
    INTERNATIONAL: 'yyyy-MM-dd',
    US: 'MM-dd-yyyy',
    DEFAULT: 'yyyyMMdd',
  },
  LABEL: {
    FR: {
      FR: 'jj/mm/aaaa',
      INTERNATIONAL: 'aaaa-mm-jj',
      US: 'mm-jj-aaaa',
      DEFAULT: 'aaaammjj',
    },
    EN: {
      FR: 'dd/mm/yyyy',
      INTERNATIONAL: 'yyyy-mm-dd',
      US: 'mm-dd-yyyy',
      DEFAULT: 'yyyymmdd',
    },
  },
};
export const DATES_FORMATS = [
  {
    value: 'dd/MM/yyyy',
    label: 'FR',
  },
  {
    value: 'yyyy-MM-dd',
    label: 'INTERNATIONAL',
  },
  { value: 'MM-dd-yyyy', label: 'US' },
  { value: 'yyyyMMdd', label: 'DEFAULT' },
];

export const FILE_TYPE = {
  QUADRA: 'QUADRA',
  OTHERS: 'OTHERS',
};

export const KYC_STATUS = {
  ERROR: 'ERROR',
  KO: 'KO',
  OK: 'OK',
  WARN: 'WARN',
  PARTIAL_OK: 'PARTIAL_OK',
  STARTED: 'STARTED',
  PENDING: 'PENDING',
  PROCESS_ERROR: 'KYC_PROCESS_ERROR',
};

export const PAGES = {
  med: 'formal-notice',
  cases: 'cases',
  tiers: 'tiers',
  'cash-collection': 'cash-collection',
  disputes: 'disputes',
  alert: 'alert',
};

export const ACTION_CODES = {
  PRESTA_RECOUVREMENT: 'presta_recouvrement',
  PIECES_JOINTES: 'pieces_jointes',
};

export const TYPE_PROCEDURE_TOUS = 'TOUS';

export const TYPE_PERIOD_QUARTERLY = 'QUARTERLY';

export const TYPE_PERIOD_YEARLY = 'YEARLY';

export const TYPE_PERIOD_MONTHLY = 'MONTHLY';

export const CROSS_DOMAIN = {
  LISTE_BLANCHE_ORIGINS: {
    SITE_VITRINE: 'https://assets.intractiv.com',
  },
  // Pattern utilisé pour vérifier la bonne structure des JSON stringifiés reçus.
  PATTERN: {
    GENERAL: '',
    CONSENT_STATE: '',
    ATTRIBUTION: '',
    USER_DATA: '',
    USER_PROPERTIES: '',
    CONTEXT: '',
    EVENTS: '',
  },
};

export const SUBSCRIPTION_PRICE_FULL = 490;

export const DATA_INTEGRATION_INCREMENTAL_MODE = 'INCREMENTAL';

export enum DataIntegrationMode {
  Incremental = DATA_INTEGRATION_INCREMENTAL_MODE,
}

export const TRACKING_VARIABLES = {
  ACTIPAY_USER: 'ACTIPAY_USER',
};
